module.exports = __webpack_public_path__ + "media/images/platforms/playstation/background-7b8901f82e2fec38c5ea0777a2e779a3.jpg";